import { FileArchive, FileIcon, FileSpreadsheet, FileText } from 'lucide-react';

export function getFileDisplaySize(file: File) {
  const sizeInKB = file.size / 1024;
  const isMB = sizeInKB >= 1024;
  const displaySize = isMB ? (sizeInKB / 1024).toFixed(2) : sizeInKB.toFixed(2);
  const displayUnit = isMB ? 'MB' : 'KB';

  return { displaySize, displayUnit };
}

export function getIconByFileType(type: string) {
  if (type.includes('spreadsheetml') || type.includes('sheet')) {
    return <FileSpreadsheet size="30px" color="currentColor" />;
  } else if (type.includes('zip')) {
    return <FileArchive size="30px" color="currentColor" />;
  } else if (type.includes('text') || type.includes('pdf')) {
    return <FileText size="30px" color="currentColor" />;
  }
  return <FileIcon size="30px" color="currentColor" />;
}
